export default __webpack_public_path__ + "static/media/logo2.142b201b.png";